<template>
  <div>
    <b-tabs v-model="selectedTab"
            card>

      <b-row align-h="between"
             class="container-fluid"
             no-gutters>

        <b-col cols="auto">
          <b-row id="filters">
            <b-col cols="auto">
              <b-button :pressed.sync="showFilter"
                        class="mb-2 mr-2">
                FILTER
              </b-button>
            </b-col>

            <b-col cols="auto">
              <keep-alive>
                <call-filter v-if="isNotReportsTab"
                             :id="id"
                             ref="call_filter"
                             v-model="proposals"
                             :loading="loading"
                             all-calls
                             @load-data="loadDataFor"
                             @selected-call-change="callChange"
                             @update-proposals="refreshProposals"/>
              </keep-alive>
            </b-col>

            <b-col v-if="isManagementEvaluation && isNotReportsTab">
              <b-button v-b-modal.callShiftsModal
                        :disabled="!showCallDetailsButton"
                        :title="showCallDetailsButton ? '' : 'Available only to the coordinator'"
                        class="mb-2 mr-2"
                        variant="info">
                Call details
              </b-button>
              <b-modal id="callShiftsModal"
                       lazy
                       title="Call details"
                       variant="outline-primary"
                       @hide="revertCallDataForModal"
                       @ok="saveShiftsData">
                <call-data v-model="callEnvForModal"
                           :call-data="callDataForModal"
                           :isManagementEvaluation="true"
                           :isManagementEvaluationCryoem="isCryoemManagementEvaluationDashboard"
                           class="mt-1"/>
              </b-modal>
            </b-col>
          </b-row>
        </b-col>

        <b-col cols="auto">
          <b-row class="mt-3">
            <b-col class="mb-2"
                   cols="auto">
              <action-submit-all-button v-if="isSubmitAllButtonVisible"
                                        :config="gradeHelpers.submitAllConfig"
                                        :selected-call="selectedCall"
                                        @reload-proposals="loadDataFor(selectedCall)"/>
            </b-col>
            <b-col v-if="isProposalsToZipEnabled"
                   class="mb-2"
                   cols="auto">
              <button-spinner :loading="zipLoading"
                              :spinner="{color: 'warning'}"
                              variant="info"
                              @click="downloadZipWrapper">
                <template v-slot:defaultText>
                  <span>PROPOSALS TO ZIP ({{ buttonZipTextAppend }})</span>
                </template>
              </button-spinner>
            </b-col>
          </b-row>
        </b-col>

      </b-row>

      <b-tab :title="mainTabTitle"
             active>
        <shifts-counter-wrapper :call-name="selectedCall"
                                :infrastructure="infrastructure"
                                :isManagementEvaluation="isManagementEvaluation"
                                :proposals="allProposalsForCall"
                                @input="setShiftsCounterData($event)"/>

        <div v-if="isCryoemFinalGradeDashboard">
          <p class="ml-3 p-form-description">1-day shift for proposals submitted after Spring 2024 - 13th call</p>
          <p class="ml-3 p-form-description">2.5-day shift for proposals submitted until Spring 2024 – 13th call</p>
        </div>

        <grade-table :gradeHelpers="gradeHelpers"
                     :isManagementEvaluation="isManagementEvaluation"
                     :loading="loading"
                     :parent="id"
                     :proposals="proposals"
                     :selected-call="selectedCall"
                     :shiftsCounterData="shiftsCounterData"
                     :userElevatedPermissions="userElevatedPermissions"
                     @filtered-proposals="updateFilteredProposals($event, 0)"
                     @update-proposal="updateProposal($event)"/>
      </b-tab>
      <template v-if="!isManagementEvaluation">
        <b-tab title="Reviews">
          <final-grade-reviews v-if="helpersDataLoaded"
                               :parent="id"
                               :proposals="proposals"
                               :selected-call="selectedCall"
                               @update-proposal="updateProposal($event)"
                               @filtered-proposals="updateFilteredProposals($event, 1)"/>
        </b-tab>
      </template>
      <b-tab lazy
             title="Reports">
        <experiment-list v-if="helpersDataLoaded"
                         :elevated="false"
                         :load_data_url="finalGradeHelpers.experimentsUrl"
                         :prop_fields="finalGradeHelpers.finalGradeReportFields"
                         :show_filter="showFilter"
                         :show_zip_button="true"/>
      </b-tab>
      <template v-if="!isManagementEvaluation">
        <b-tab v-if="userElevatedPermissions.isEditor"
               title="Add Reviewer">
          <final-grade-select-reviewers :parent-id="id"
                                        :proposals="proposals"
                                        :selected-call="selectedCall"
                                        @setup-proposal="emitSetupProposal($event)"/>
        </b-tab>
      </template>
    </b-tabs>
  </div>
</template>

<script>
  import ActionSubmitAllButton from '@/components/actions/ActionSubmitAllButton';
  import ButtonSpinner from '@/components/buttonSpinner';
  import CallFilter from '@/components/call_filter';
  import { infrastructureMixin } from '@/mixins/infrastructure';
  import ExperimentList from '@/components/proposal/experiment-report/experiment_list';
  import FinalGradeReviews from '@/components/evaluation/final-grade/FinalGradeReviews';
  import FinalGradeSelectReviewers from '@/components/evaluation/final-grade/FinalGradeSelectReviewers';
  import GradeTable from '@/components/evaluation/GradeTable';
  import ShiftsCounterWrapper from '@/components/shifts-counter/ShiftsCounterWrapper';
  import CallData from '@/components/CallData';

  export default {
    name: 'GradeDashboard',
    components: {
      ActionSubmitAllButton,
      ButtonSpinner,
      CallFilter,
      ExperimentList,
      FinalGradeSelectReviewers,
      FinalGradeReviews,
      GradeTable,
      ShiftsCounterWrapper,
      CallData,
    },
    mixins: [infrastructureMixin],
    props: {
      gradeHelpers: {
        type: Object,
        required: true,
      },
      isManagementEvaluation: {
        type: Boolean,
        default: false,
      },
      mainTabTitle: {
        type: String,
        default: 'Final grades',
      },
    },
    data() {
      return {
        proposals: [],
        filteredProposals: {},
        allProposalsLengths: {},
        buttonZipTextAppend: 'ALL',
        id: 0,
        selectedCall: '',
        call: {},
        callEnvForModal: [],
        callDataForModal: {},
        roles: [],
        showFilter: true,
        selectedTab: 0,
        environments: [],
        shiftsCounterData: {},
        loading: false,
        zipLoading: false,
        allProposalsForCall: [],
        helpersDataLoaded: false,
        finalGradeHelpers: {},
      };
    },
    computed: {
      isCryoemFinalGradeDashboard() {
        return this.infrastructure === 'cryoem' && !this.isManagementEvaluation;
      },
      isCryoemManagementEvaluationDashboard() {
        return this.infrastructure === 'cryoem' && this.isManagementEvaluation;
      },
      isSynchrotronManagementEvaluationDashboard() {
        return this.infrastructure === 'synchrotron' && this.isManagementEvaluation;
      },
      isProposalsToZipEnabled() {
        return (this.selectedTab < 2) && (this.selectedTab !== this.reportsTabId);
      },
      reportsTabId() {
        return this.isManagementEvaluation ? 1 : 2;
      },
      isNotReportsTab() {
        return this.selectedTab !== this.reportsTabId;
      },
      isSubmitAllButtonVisible() {
        return this.userElevatedPermissions.isSubmitter && this.selectedTab === 0;
      },
      userElevatedPermissions() {
        const permissions = this.$store.getters['login/getLoggedUserAttribute']('permissions') || [];
        return {
          isEditor: permissions.includes(this.gradeHelpers.editorPermission),
          isSubmitter: permissions.includes(this.gradeHelpers.submitterPermission),
        };
      },
      isSingleCallSelected() {
        return this.selectedCall !== 'All calls';
      },
      isUserCryoemCoordinatorOnCryoemView() {
        if (this.isCryoemManagementEvaluationDashboard) {
          const cryoemCoordinatorRole = this.gradeHelpers.managementEvaluatorCryoemRole;
          return cryoemCoordinatorRole ? this.roles.includes(cryoemCoordinatorRole) : false;
        }
        return false;
      },
      isUserBeamlineCoordinatorOnSynchrotronView() {
        if (this.isSynchrotronManagementEvaluationDashboard) {
          const beamlineCoordinatorRoles = this.gradeHelpers.managementEvaluatorBeamlineRoles;
          return beamlineCoordinatorRoles && Array.isArray(beamlineCoordinatorRoles)
            ? beamlineCoordinatorRoles.some((item) => this.roles.includes(item))
            : false;
        }
        return false;
      },
      showCallDetailsButton() {
        return (this.isUserBeamlineCoordinatorOnSynchrotronView || this.isUserCryoemCoordinatorOnCryoemView)
          && this.isSingleCallSelected;
      },
    },
    watch: {
      selectedTab() {
        this.$emit('refresh');
        this.updateButtonZipTextAppend();
      },
      showFilter() {
        this.$emit('toggle-show');
      },
      selectedCall(newCallName) {
        if (this.isSingleCallSelected && this.isManagementEvaluation) {
          this.setSelectedCallData(newCallName);
        }
      },
    },
    async created() {
      const finalGradeHelpers = await this.getEvaluationDashboardProperties(this.infrastructure, 'FinalGrade');
      this.finalGradeHelpers = finalGradeHelpers.getAsObject(
        'experimentsUrl',
        'finalGradeReportFields',
      );
      this.helpersDataLoaded = true;

      this.roles = this.$store.getters['login/getLoggedUserAttribute']('roles') || [];
    },
    methods: {
      updateFilteredProposals(proposals, tabId) {
        this.filteredProposals[tabId] = proposals;
        this.updateButtonZipTextAppend();
      },
      updateButtonZipTextAppend() {
        if (this.filteredProposals[this.selectedTab] === undefined
          || this.allProposalsLengths[this.selectedTab] === undefined) {
          this.buttonZipTextAppend = 'ALL';
        } else {
          const allProposalsLength = this.allProposalsLengths[this.selectedTab];
          const filteredProposalsLength = this.filteredProposals[this.selectedTab].length;
          this.buttonZipTextAppend = allProposalsLength === filteredProposalsLength ? 'ALL'
            : filteredProposalsLength.toString();
        }
      },
      filteredProposalIDRange() {
        const uniqueProposalIds = new Set();
        this.filteredProposals[this.selectedTab].forEach((obj) => {
          if (obj.document_specification && obj.document_specification.document_id) {
            uniqueProposalIds.add(obj.document_specification.document_id);
          }
        });
        return Array.from(uniqueProposalIds);
      },
      async downloadZipWrapper() {
        this.zipLoading = true;
        // eslint-disable-next-line camelcase
        const proposalIDRange = { proposal_id_range: this.filteredProposalIDRange() };
        const callParam = { call: this.$refs.call_filter?.selectedCall ?? null };
        await this.downloadZip(callParam, proposalIDRange);
        this.zipLoading = false;
      },
      getReviewsGrades(reviewsList) {
        return reviewsList
          .filter((item) => (item.states?.name === 'submitted' || item.states?.name === 'draft') && item.grade !== '')
          .map((item) => Number(item.grade))
          .filter(Number.isFinite);
      },
      getReviewsAverage(reviewsList) {
        const reviews = this.getReviewsGrades(reviewsList);
        if (!reviews.length) {
          return '';
        }
        const sumOfReviewsGrades = reviews.reduce((total, currentGrade) => total + currentGrade, 0);
        return (sumOfReviewsGrades / reviews.length).toFixed(2);
      },
      getReviewsStandardDeviation(reviewsList) {
        const reviews = this.getReviewsGrades(reviewsList);
        if (!reviews.length) {
          return '';
        }
        const reviewsAverage = this.getReviewsAverage(reviewsList);
        const reviewsStandardDeviation = Math.sqrt(
          reviews.reduce(
            (total, currentGrade) => total + (currentGrade - reviewsAverage) ** 2,
            0,
          ) / reviews.length,
        );
        return reviewsStandardDeviation.toFixed(2);
      },
      async loadDataFor(call) {
        this.loading = true;
        const callParam = { call };
        const gradeTypePath = this.isManagementEvaluation ? 'management-evaluation' : 'final-grades';
        const response = await this.axios.get(
          `/documents/${gradeTypePath}/${this.infrastructure}`,
          { params: callParam },
        );
        if (response.data) {
          this.proposals = response.data.documents.map((proposal) => {
            if (this.isManagementEvaluation) {
              const { management_evaluation = {} } = proposal;
              // eslint-disable-next-line camelcase
              management_evaluation.acceptance_mark = management_evaluation.acceptance_mark || '';
              // eslint-disable-next-line camelcase
              return { ...proposal, management_evaluation };
            }
            const {
              final_grade = {},
              reviewsAverage = proposal.reviews ? this.getReviewsAverage(proposal.reviews) : '',
              reviewsStandardDeviation = proposal.reviews ? this.getReviewsStandardDeviation(proposal.reviews) : '',
            } = proposal;
            // eslint-disable-next-line camelcase
            final_grade.acceptance_mark = final_grade.acceptance_mark || '';
            // eslint-disable-next-line camelcase
            return { ...proposal, final_grade, reviewsAverage, reviewsStandardDeviation };
          });
          this.$set(this, 'allProposalsForCall', this.proposals);
          // setup the data in proposal-filter, call-filter component
          this.$emit('setup-proposal', this.proposals);
          // load data from children component
          this.$emit('load-data');
          this.allProposalsLengths = { 0: this.proposals.length };
          if (!this.isManagementEvaluation) {
            this.allProposalsLengths[1] = this.proposals.length;
          }
          this.loading = false;
        } else {
          this.$notify({ type: 'error', title: 'Something went wrong' });
          this.proposals = [];
          this.loading = false;
        }
      },
      refreshProposals(proposals) {
        this.refreshProposalsFilter(proposals);
        this.$set(this, 'allProposalsForCall', this.proposals);
      },
      setSelectedCallData(callName) {
        const { calls } = this.$store.state.calls;
        const selectedCall = calls.find((call) => call.name === callName);
        const selectedCallId = selectedCall ? this.getId(selectedCall) : '';
        this.$store.dispatch('calls/get_call', selectedCallId).then((selectedCall) => {
          this.call = selectedCall.data;
          this.callEnvForModal = this.call.environments;
          this.callDataForModal = this.parseEnv(this.$_.cloneDeep(this.call.data)) ?? {};
        });
      },
      parseEnv(data) {
        Object.entries(this.callEnvForModal).forEach(([index, val]) => {
          if (this.hasProperty(this.callEnvForModal, index) && data !== undefined && !(val in data)) {
            // eslint-disable-next-line no-param-reassign
            data[val] = {};
          }
        });
        return data;
      },
      revertCallDataForModal() {
        this.callDataForModal = this.parseEnv(this.$_.cloneDeep(this.call.data)) ?? {};
      },
      saveShiftsData() {
        this.call.data = this.$_.cloneDeep(this.callDataForModal);
        this.$store.dispatch('calls/save_call_changes', this.call).then(
          () => {
            this.$store.dispatch('calls/get_call', this.getId(this.call));
            this.$notify({ title: 'Shifts saved successfully!' });
          },
          () => {
            this.$notify({ title: 'Shifts cannot be saved!', type: 'warn' });
          },
        );
      },
      setShiftsCounterData(shiftsCounterData) {
        this.shiftsCounterData = shiftsCounterData;
        this.$emit('setup-shifts-counter-data', shiftsCounterData);
      },
      updateProposal(proposal) {
        const index = this.proposals.findIndex((el) => this.getId(el) === this.getId(proposal));
        if (index >= 0) {
          this.$set(this.proposals, index, proposal);
        }
      },
    },
  };
</script>

<style lang="scss" scoped>
  .card {
    margin: 4rem;
  }

  #filters {
    margin-top: 1rem;
  }
</style>
